import React from 'react';
import { Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-react';
import { Link as RouterLink } from 'react-router-dom';

class Link extends React.Component {
    
    constructor(props) {
        super(props);    
        this.render=this.render.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
    }
    
    handleOnClick(e) {
        if (!!this.props.onClick){
            this.props.onClick(e);
        }
    }

    render () {
        const { forwardedRef, router = true, ...rest } = this.props;
        const hasValidHref = (this.props.field && this.props.field.value && this.props.field.value.href) || this.props.href;
        const isEditing = this.props.editable && this.props.field.editable;

        if (hasValidHref && !isEditing && router) {
            var value;
            if(this.props.field) {
                value = this.props.field.value;
            }
            else {
                value = {
                        href : this.props.href,
                        target : this.props.target,
                        title : this.props.title
                };
            }
            let hrefHasOrigin = (typeof window !== 'undefined' && window?.location?.origin && value.href.startsWith(window.location.origin));
            if(value.href.startsWith('/') || hrefHasOrigin) {
                return (
                    <RouterLink
                        onClick={this.handleOnClick}
                        to={(hrefHasOrigin) ? value.href.replace(window.location.origin, '') || '/' : value.href}
                        title={value.title}
                        target={value.target}
                        className={this.props.className}
                        style={this.props.style}
                        ref={forwardedRef}
                    >
                    {this.props.children || value.text || value.href}
                    </RouterLink>
                );
            }
        }
        const target = this.props?.field?.value?.target ?? this.props.target;        ;
        if (this.props.field)
            return <SitecoreLink {...rest} ref={forwardedRef} target={target} />;
        else //recreate props from href and other values
            return <SitecoreLink {...rest} field={value} ref={forwardedRef} target={target} />
    }
}

// Wrapper function to forward the ref
function forwardRefWrapper(props, ref) {
    return <Link {...props} forwardedRef={ref} />;
}

export default React.forwardRef(forwardRefWrapper);